import React from "react";
import { Link , useLocation } from "react-router-dom";

function Nav() {
  const {pathname}  = useLocation();
  console.log(pathname); 
  return (
    <nav>
        <Link to="/" ><img src="images/logo.svg" alt="" /></Link>
        <div className="nav-links">
          <Link className={pathname ==="/" ? "active" : ""} to="/">Accueil</Link>
          <Link className={pathname ==="/about" ? "active" : ""}  to="/about">A propos</Link>
          <Link className={pathname ==="/contact" ? "active" : ""}  to="/contact">Contact</Link>
        </div>
    </nav>
  );
}

export default Nav;
